<template>
    <div class="sidebar-wrapper" data-simplebar="true">
        <div class="sidebar-header">
            <div class="logo-wrap">
                <span class="logo-mark">VL</span>
                <div class="logo-copy">
                    <h4 class="logo-text">Village Landmark</h4>
                    <span class="logo-sub">Management</span>
                </div>
            </div>
            <div class="toggle-icon ms-auto" @click="isToggled = !isToggled">
                <i class='bx' :class="toggleClass()"></i>
            </div>
        </div>
        <!--navigation-->
        <ul class="metismenu" id="menu">
            <li class="menu-label">Main</li>
            <li>
                <router-link :to="{name: 'dashboard'}">
                    <div class="parent-icon"><i class='bx bx-home-circle'></i>
                    </div>
                    <div class="menu-title">Dashboard</div>
                </router-link>
            </li>
            <li class="menu-label">Setup</li>
            <li>
                <a href="javascript:void(0);" class="has-arrow">
                    <div class="parent-icon"><i class="bx bx-cog"></i>
                    </div>
                    <div class="menu-title">Settings</div>
                </a>
                <ul>
                    <li :class="isActive('project')">
                        <router-link :to="{name: 'project'}"><i class="bx bx-right-arrow-alt"></i>Project </router-link>
                    </li>
                    <li :class="isActive('district')">
                        <router-link :to="{name: 'district'}"><i class="bx bx-right-arrow-alt"></i>District </router-link>
                    </li>
                    <li :class="isActive('area')">
                        <router-link :to="{name: 'area'}"><i class="bx bx-right-arrow-alt"></i>Area</router-link>
                    </li>
                    <li :class="isActive('designation')">
                        <router-link :to="{name: 'designation'}"><i class="bx bx-right-arrow-alt"></i>Designation
                        </router-link>
                    </li>
                    <li :class="isActive('slot')">
                        <router-link :to="{name: 'slot'}"><i class="bx bx-right-arrow-alt"></i>Slot
                        </router-link>
                    </li>
                    <li :class="isActive('construction')">
                        <router-link :to="{name: 'construction'}"><i class="bx bx-right-arrow-alt"></i>Construction
                        </router-link>
                    </li>
                    <li :class="isActive('investorCategory')">
                        <router-link :to="{name: 'investorCategory'}"><i class="bx bx-right-arrow-alt"></i>Investor Category
                        </router-link>
                    </li>
                    <li :class="isActive('unit')">
                        <router-link :to="{name: 'unit'}"><i class="bx bx-right-arrow-alt"></i>Unit
                        </router-link>
                    </li>
                    <li :class="isActive('rawMaterial')">
                        <router-link :to="{name: 'rawMaterial'}"><i class="bx bx-right-arrow-alt"></i>Raw Material
                        </router-link>
                    </li>
                    <li :class="isActive('expenseCategory')">
                        <router-link :to="{name: 'expenseCategory'}"><i class="bx bx-right-arrow-alt"></i>Expense Category
                        </router-link>
                    </li>
                    <li :class="isActive('incomeCategory')">
                        <router-link :to="{name: 'incomeCategory'}"><i class="bx bx-right-arrow-alt"></i>Income Category
                        </router-link>
                    </li>
                    <li :class="isActive('bank')">
                        <router-link :to="{name: 'bank'}"><i class="bx bx-right-arrow-alt"></i>Bank
                        </router-link>
                    </li>
                    <li :class="isActive('supplier')">
                        <router-link :to="{name: 'supplier'}"><i class="bx bx-right-arrow-alt"></i>Supplier
                        </router-link>
                    </li>
                    <li :class="isActive('interest')">
                        <router-link :to="{name: 'interest'}"><i class="bx bx-right-arrow-alt"></i>Interest
                        </router-link>
                    </li>
                    <li :class="isActive('contact')">
                        <router-link :to="{name: 'contact'}"><i class="bx bx-right-arrow-alt"></i>Contact
                        </router-link>
                    </li>
                    <li :class="isActive('specialExpense')">
                        <router-link :to="{name: 'specialExpense'}"><i class="bx bx-right-arrow-alt"></i>Special Expense
                        </router-link>
                    </li>
                    <li :class="isActive('cashReceived')">
                        <router-link :to="{name: 'cashReceived'}"><i class="bx bx-right-arrow-alt"></i>Cash Received
                        </router-link>
                    </li>
                    <li :class="isActive('costingItem')">
                        <router-link :to="{name: 'costingItem'}"><i class="bx bx-right-arrow-alt"></i>Costing Item
                        </router-link>
                    </li>
                    <li :class="isActive('customerReference')">
                        <router-link :to="{name: 'customerReference'}"><i class="bx bx-right-arrow-alt"></i>Customer Reference
                        </router-link>
                    </li>
                    <li :class="isActive('salesPerson')">
                        <router-link :to="{name: 'salesPerson'}"><i class="bx bx-right-arrow-alt"></i>Sales Person
                        </router-link>
                    </li>
                </ul>
            </li>
            <li class="menu-label">Operations</li>
            <li>
                <router-link :to="{name: 'shareholder'}" class="">
                    <div class="parent-icon"><i class="bx bx-user"></i>
                    </div><div class="menu-title">Shareholder</div>
                </router-link>
            </li>
            <li>
                <a href="javascript:void(0);" class="has-arrow">
                    <div class="parent-icon"><i class="bx bx-calculator"></i>
                    </div>
                    <div class="menu-title">Accounts</div>
                </a>
                <ul>
                    <li :class="isActive('income')">
                        <router-link :to="{name: 'income'}"><i class="bx bx-right-arrow-alt"></i>Income</router-link>
                    </li>
                    <li :class="isActive('expense')">
                        <router-link :to="{name: 'expense'}"><i class="bx bx-right-arrow-alt"></i>Expense</router-link>
                    </li>
                </ul>
            </li>
            <li>
                <router-link :to="{name: 'customer'}" class="">
                    <div class="parent-icon"><i class="bx bx-male"></i>
                    </div><div class="menu-title">Customer</div>
                </router-link>
            </li>
            <li>
                <router-link :to="{name: 'order'}" class="">
                    <div class="parent-icon"><i class="bx bx-cart"></i>
                    </div><div class="menu-title">Order</div>
                </router-link>
            </li>
            <li>
                <router-link :to="{name: 'purchase'}" class="">
                    <div class="parent-icon"><i class="bx bx-purchase-tag"></i>
                    </div><div class="menu-title">Purchase</div>
                </router-link>
            </li>
            <li>
                <router-link :to="{name: 'bankWithdrawList'}" class="">
                    <div class="parent-icon"><i class="bx bx-purchase-tag"></i>
                    </div><div class="menu-title">Bank Withdraw</div>
                </router-link>
            </li>
            <li>
                <router-link :to="{name: 'addSlot'}" class="">
                    <div class="parent-icon"><i class="bx bx-grid-alt"></i>
                    </div><div class="menu-title">Add Slot</div>
                </router-link>
            </li>
            <li>
                <router-link :to="{name: 'rawMaterialProfit'}" class="">
                    <div class="parent-icon"><i class="bx bx-purchase-tag"></i>
                    </div><div class="menu-title">Raw Material Profit</div>
                </router-link>
            </li>
            <li class="menu-label">Analytics</li>
            <li>
                <a href="javascript:void(0);" class="has-arrow">
                    <div class="parent-icon"><i class="bx bx-bar-chart-alt-2"></i>
                    </div>
                    <div class="menu-title">Report</div>
                </a>
                <ul>
<!--                    <li :class="isActive('incomeReport')">-->
<!--                        <router-link :to="{name: 'incomeReport'}"><i class="bx bx-right-arrow-alt"></i>Income-->
<!--                        </router-link>-->
<!--                    </li>-->
<!--                    <li :class="isActive('expenseReport')">-->
<!--                        <router-link :to="{name: 'expenseReport'}"><i class="bx bx-right-arrow-alt"></i>Expense-->
<!--                        </router-link>-->
<!--                    </li>-->
                    <li :class="isActive('balanceSheet')">
                        <router-link :to="{name: 'balanceSheet'}"><i class="bx bx-right-arrow-alt"></i>Balance Sheet
                        </router-link>
                    </li>
                    <li :class="isActive('depositAmountReport')">
                        <router-link :to="{name: 'depositAmountReport'}"><i class="bx bx-right-arrow-alt"></i>Deposit Amount Top Sheet
                        </router-link>
                    </li>
                    <li :class="isActive('slotReport')">
                        <router-link :to="{name: 'slotReport'}"><i class="bx bx-right-arrow-alt"></i>Slot Report
                        </router-link>
                    </li>
                    <li :class="isActive('slotVsDepositByProject')">
                        <router-link :to="{name: 'slotVsDepositByProject'}"><i class="bx bx-right-arrow-alt"></i>Slot Vs Deposit by Project
                        </router-link>
                    </li>
                    <li :class="isActive('slotVsDepositByShareholder')">
                        <router-link :to="{name: 'slotVsDepositByShareholder'}"><i class="bx bx-right-arrow-alt"></i>Slot Vs Deposit by Shareholder
                        </router-link>
                    </li>
                    <li :class="isActive('depositDetailsByShareholder')">
                        <router-link :to="{name: 'depositDetailsByShareholder'}"><i class="bx bx-right-arrow-alt"></i>Deposit Details by Shareholder
                        </router-link>
                    </li>
                    <li :class="isActive('cashReceivedReport')">
                        <router-link :to="{name: 'cashReceivedReport'}"><i class="bx bx-right-arrow-alt"></i>Cash Received
                        </router-link>
                    </li>
                    <li :class="isActive('incomeCategoryReport')">
                        <router-link :to="{name: 'incomeCategoryReport'}"><i class="bx bx-right-arrow-alt"></i>Income Category
                        </router-link>
                    </li>
                    <li :class="isActive('expenseCategoryReport')">
                        <router-link :to="{name: 'expenseCategoryReport'}"><i class="bx bx-right-arrow-alt"></i>Expense Category
                        </router-link>
                    </li>
                    <li :class="isActive('supplierReport')">
                        <router-link :to="{name: 'supplierReport'}"><i class="bx bx-right-arrow-alt"></i>Supplier
                        </router-link>
                    </li>
                    <li :class="isActive('rawMaterialReport')">
                        <router-link :to="{name: 'rawMaterialReport'}"><i class="bx bx-right-arrow-alt"></i>Raw Material
                        </router-link>
                    </li>
                    <li :class="isActive('paymentMethodReport')">
                        <router-link :to="{name: 'paymentMethodReport'}"><i class="bx bx-right-arrow-alt"></i>Payment Method
                        </router-link>
                    </li>
                    <li :class="isActive('rawMaterialAmount')">
                        <router-link :to="{name: 'rawMaterialAmount'}"><i class="bx bx-right-arrow-alt"></i>Raw Material Amount
                        </router-link>
                    </li>
                    <li :class="isActive('supplierAmount')">
                        <router-link :to="{name: 'supplierAmount'}"><i class="bx bx-right-arrow-alt"></i>Supplier Amount
                        </router-link>
                    </li>
                    <li :class="isActive('rawMaterialPurchase')">
                        <router-link :to="{name: 'rawMaterialPurchase'}"><i class="bx bx-right-arrow-alt"></i>Raw Material Purchase
                        </router-link>
                    </li>
                    <li :class="isActive('specialExpenseReport')">
                        <router-link :to="{name: 'specialExpenseReport'}"><i class="bx bx-right-arrow-alt"></i>Special Expense
                        </router-link>
                    </li>
                    <li :class="isActive('costingItemReport')">
                        <router-link :to="{name: 'costingItemReport'}"><i class="bx bx-right-arrow-alt"></i>Costing Item
                        </router-link>
                    </li>
                    <li :class="isActive('purchaseByReport')">
                        <router-link :to="{name: 'purchaseByReport'}"><i class="bx bx-right-arrow-alt"></i>Purchase By
                        </router-link>
                    </li>
                    <li :class="isActive('shareHolderDepositReport')">
                        <router-link :to="{name: 'shareHolderDepositReport'}"><i class="bx bx-right-arrow-alt"></i>Shareholder Deposit
                        </router-link>
                    </li>
                    <li :class="isActive('shareHolderProfitLossReport')">
                        <router-link :to="{name: 'shareHolderProfitLossReport'}"><i class="bx bx-right-arrow-alt"></i>Shareholder Profit & Loss
                        </router-link>
                    </li>
                    <li :class="isActive('categoryTopSheetReport')">
                        <router-link :to="{name: 'categoryTopSheetReport'}"><i class="bx bx-right-arrow-alt"></i>Category Top Sheet
                        </router-link>
                    </li>
                    <li :class="isActive('dayWiseExpenseReport')">
                        <router-link :to="{name: 'dayWiseExpenseReport'}"><i class="bx bx-right-arrow-alt"></i>Day Wise Expense
                        </router-link>
                    </li>
                    <li :class="isActive('dayWiseDepositReport')">
                        <router-link :to="{name: 'dayWiseDepositReport'}"><i class="bx bx-right-arrow-alt"></i>Day Wise Deposit
                        </router-link>
                    </li>
                    <li :class="isActive('shareHolderYearlyDepositReport')">
                        <router-link :to="{name: 'shareHolderYearlyDepositReport'}"><i class="bx bx-right-arrow-alt"></i>Yearly Deposit Report
                        </router-link>
                    </li>
                    <li :class="isActive('categoryYearlyExpenseReport')">
                        <router-link :to="{name: 'categoryYearlyExpenseReport'}"><i class="bx bx-right-arrow-alt"></i>Yearly Expense Report
                        </router-link>
                    </li>
                    <li :class="isActive('comparisonExpenseSheetReport')">
                        <router-link :to="{name: 'comparisonExpenseSheetReport'}"><i class="bx bx-right-arrow-alt"></i>Comparison Expense Sheet
                        </router-link>
                    </li>
                </ul>
            </li>
        </ul>
        <!--end navigation-->
    </div>
</template>

<script>
import CategoryService from "../../Services/CategoryService";

export default {
    data: function () {
        return {
            isToggled: false,
            categoryTypes: CategoryService
        }
    },
    methods: {
        toggleClass: function () {
            if (this.isToggled) {
                return 'bx-arrow-to-right'
            } else {
                return 'bx-arrow-to-left'
            }
        },
        isActive: function (routeName) {
            return this.$route.name === routeName ? 'mm-active' : ''
        }
    },
}
</script>

<style scoped>
.logo-wrap {
    display: flex;
    align-items: center;
    gap: 0.65rem;
    min-width: 0;
}

.logo-mark {
    width: 34px;
    height: 34px;
    border-radius: 9px;
    background: #2563eb;
    color: #fff;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.4px;
    flex-shrink: 0;
}

.logo-copy {
    min-width: 0;
    line-height: 1.15;
}

.logo-text {
    font-size: 14px !important;
    font-weight: 500 !important;
    margin: 0 !important;
    letter-spacing: 0.2px !important;
    color: #0f172a !important;
    white-space: nowrap;
}

.logo-sub {
    display: block;
    font-size: 11px;
    color: #94a3b8;
    font-weight: 400;
    letter-spacing: 0.2px;
}
</style>
